module.exports = __webpack_public_path__ + "static/media/compose_topic.fea2156e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/brite/compose_topic.png
// module id = 284
// module chunks = 0